import { BulkEmailStepperProps } from '../interface/interface';

const BulkEmailStepper = (props: BulkEmailStepperProps) => {
  return (
    <nav aria-label="Progress" className="flex items-center justify-center">
      <p className="text-sm font-medium">
        Step {props.currentStep + 1} of {props.steps.length}
      </p>
      <ol role="list" className="ml-8 flex items-center space-x-5">
        {props.steps.map((step, index) => (
          <li key={step.id}>
            <button className="relative flex items-center justify-center">
              {props.currentStep === index && (
                <span aria-hidden="true" className="absolute flex size-5 p-px">
                  <span className="size-full rounded-full bg-indigo-200" />
                </span>
              )}
              <span
                aria-hidden="true"
                className="relative block size-2.5 rounded-full bg-indigo-600"
              />
            </button>
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default BulkEmailStepper;
